import script from "./CompositeIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompositeIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CompositeIcon.vue?vue&type=style&index=0&id=04f82114&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f82114"]])

export default __exports__